export const translations = {
  en: {
    nav: {
      home: 'Home',
      product: 'Product',
      installation: 'Installation',
      manual: 'User Manual',
      about: 'About Us',
      contact: 'Contact Us'
    },
    product: {
      title: 'ThermoPied',
      learnMore: 'Learn More',
      whyChoose: 'Why Choose ThermoPied?',
      tagline: 'Engineered for performance. Designed for comfort. Built for the mountains.',
      whatsIncluded: "What's Included",
      heatingElements: 'Set of heating elements',
      batteries: 'Two batteries',
      chargingCable: 'Charging cable',
      warranty: '3 years warranty',
      productDescription: 'Experience superior warmth and comfort with our advanced ski boot heating system. Designed by skiers, for skiers.',
      productGallery: 'Product Gallery',
      technicalSpecs: 'Technical Specifications',
      viewSpecs: 'View Specifications (PDF)',
      ctaTitle: 'Ready to Experience Warmth?',
      ctaDescription: 'Get your ThermoPied today and never suffer from cold feet again.',
      features: {
        warmth: {
          title: 'Superior Warmth',
          description: 'Advanced heating technology keeps your feet warm in the coldest conditions'
        },
        battery: {
          title: 'Long Battery Life',
          description: 'All-day performance to match your longest ski sessions'
        },
        value: {
          title: 'Great Value',
          description: 'Premium quality at a price that makes sense for serious skiers'
        },
        reliable: {
          title: 'Reliable Performance',
          description: 'Tested by over 100 skiers with unanimous positive feedback'
        },
        mobileApp: {
          title: 'Mobile App',
          description: 'Control your heating device and monitor battery usage with our intuitive mobile app'
        }
      },
      reviews: {
        title: 'What Skiers Are Saying',
        subtitle: 'Real feedback from real skiers',
        testimonials: [
          {
            name: 'Sarah M.',
            location: 'Whistler, BC',
            rating: 5,
            text: 'Game changer! I used to cut my ski days short because of freezing toes. With ThermoPied, I can ski all day without any discomfort. The battery lasts the entire day and the heat is perfectly distributed.'
          },
          {
            name: 'Marc L.',
            location: 'Mont-Tremblant, QC',
            rating: 5,
            text: 'I\'ve tried other heated insoles before, but ThermoPied is in a different league. The app control is super convenient, and the build quality is outstanding. Worth every penny!'
          },
          {
            name: 'Jennifer K.',
            location: 'Vail, CO',
            rating: 5,
            text: 'As someone with poor circulation, cold feet have always been my biggest enemy on the slopes. ThermoPied solved this problem completely. My feet stay warm even on the coldest days. Highly recommend!'
          },
          {
            name: 'David R.',
            location: 'Jackson Hole, WY',
            rating: 5,
            text: 'Best investment I\'ve made for my ski gear! The heating is powerful yet gentle, and I love that I can adjust the temperature on the go. The 3-year warranty shows they stand behind their product.'
          }
        ]
      }
    },
    installation: {
      title: "Installation Guide",
      subtitle: 'Follow these simple steps to install your ThermoPied heating system',
      pdfTitle: 'Installation Guide',
      pdfDescription: 'View the complete installation guide with detailed instructions and diagrams',
      download: 'View Guide',
      steps: [
        {
          title: 'Prepare Your Ski Boots',
          description: 'Remove the existing insoles from your ski boots and ensure the interior is clean and dry.'
        },
        {
          title: 'Position the Heating Elements',
          description: 'Place the ThermoPied heating pads inside your boots, ensuring they are properly aligned with the toe and forefoot area.'
        },
        {
          title: 'Replace Insoles',
          description: 'Place your original insoles back over the heating elements to keep them in position.'
        },
        {
          title: 'Connect the Battery Pack',
          description: 'Attach the battery pack securely to the boot cuff. Connect the heating elements to the battery.'
        },
        {
          title: 'Power On & Adjust',
          description: 'Turn on the heating system and select your desired temperature level. Allow 5-10 minutes for optimal warmth.'
        }
      ],
      proTips: 'Pro Tips',
      tips: [
        'Test the system before heading to the slopes to ensure everything is working properly',
        'Fully charge the battery pack the night before your ski day',
        'Start with a lower heat setting and adjust as needed to maximize battery life'
      ]
    },
    manual: {
      title: 'App & User Manual',
      subtitle: 'Everything you need to know about using ThermoPied',
      pdfTitle: 'User Manual',
      pdfDescription: 'Complete guide with detailed instructions, safety information, and troubleshooting tips',
      download: 'View Manual',
      mobileAppTitle: 'Mobile App',
      mobileAppDescription: 'Download ThermoPied from the Apple Store or Google Play for complete control of temperature settings and real-time battery monitoring.',
      appStore: 'App Store',
      googlePlay: 'Google Play',
      whatsIncluded: "What's Included",
      included: [
        'Complete installation instructions',
        'Operating guidelines',
        'Battery care and maintenance',
        'Safety precautions',
        'Warranty information'
      ],
      troubleshooting: 'Troubleshooting',
      troubleshootingItems: [
        'Common issues and solutions',
        'Performance optimization tips',
        'Battery diagnostics',
        'Contact support information',
        'FAQ section'
      ]
    },
    about: {
      title: 'About Us',
      subtitle: 'Our Story',
      story: [
        "We're not just a company — we're a community of passionate skiers who know firsthand how cold feet can ruin a perfect day on the slopes. High-performance ski boots often fall short when it comes to warmth, and like many of you, we've had to end great runs too soon because of freezing toes.",
        "Frustrated by the limitations of existing heated boot solutions — whether it was the high price, poor battery life, unreliable performance, or weak warranty — we decided to take matters into our own hands.",
        "In April 2022, we teamed up with a trusted electronics company in China, founded by one of our own team members, to create a better solution: ThermoPied — a high-quality, high-performance ski boot heater designed for real skiers.",
        "After a year of development, our first batch arrived in Montreal in December 2023. Over 100 skiers tested ThermoPied throughout the entire season, and the feedback was unanimous: warmth, comfort, and reliability at a price that makes sense.",
        "ThermoPied isn't just another gadget — it's the heater we wish we had years ago. And now it's yours."
      ],
      tagline: 'ThermoPied keeps your feet warm, your body active, and your passion alive.',
      slogan: 'ThermoPied – Stay warm. Keep skiing.'
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'We\'re Here to Help',
      description: 'Have questions about ThermoPied? Need support? We\'d love to hear from you!',
      email: 'Support Email',
  emailAddress: 'info@thermopied.com',
      getInTouch: 'Get in Touch',
      storesTitle: 'Available at Leading Ski Retailers',
      storesDescription: 'This year, our products have been successfully launched and are currently available at major ski retailers:',
      stores: [
        { name: 'Lachance Ski Service', url: 'https://skilachance.com/' },
        { name: 'Sports Bromont', url: 'https://www.sportsbromont.com' },
          ,{ name: "Dinardo's Skis & Bikes", url: 'https://www.dinardoskibikehike.com/' },
       { name: "Genetik® | Vélo de montagne & Ski alpin", url: 'https://genetiksport.com/' },
       { name: "Magasin de Ski alpin", url: 'https://brunellesport.com/' },
        { name: 'Camp Base Orford – Pied Sportif', url: 'https://www.campbase.ca' },
        { name: 'Jo et Fred La Place du Ski', url: 'https://laplaceduski.ca/' },
        { name: 'Ski Shop Rive-Sud', url: 'https://www.skishoprivesud.com' }

      ]
    }
  },
  fr: {
    nav: {
      home: 'Accueil',
      product: 'Produit',
      installation: 'Installation',
      manual: 'Manuel',
      about: 'À propos',
      contact: 'Contactez-nous'
    },
    product: {
      title: 'ThermoPied',
      learnMore: 'En savoir plus',
      whyChoose: 'Pourquoi choisir ThermoPied?',
      tagline: 'Conçu pour la performance. Pensé pour le confort. Fait pour les montagnes.',
      whatsIncluded: 'Ce qui est inclus',
      heatingElements: 'Ensemble d\'éléments chauffants',
      batteries: 'Deux batteries',
      chargingCable: 'Câble de charge',
      warranty: 'Garantie de 3 ans',
      productDescription: 'Découvrez une chaleur et un confort supérieurs avec notre système de chauffage de chaussures de ski avancé. Conçu par des skieurs, pour des skieurs.',
      productGallery: 'Galerie de Produits',
      technicalSpecs: 'Spécifications Techniques',
      viewSpecs: 'Voir les Spécifications (PDF)',
      ctaTitle: 'Prêt à Découvrir la Chaleur?',
      ctaDescription: 'Obtenez votre ThermoPied aujourd\'hui et ne souffrez plus jamais des pieds froids.',
      features: {
        warmth: {
          title: 'Chaleur Supérieure',
          description: 'Technologie de chauffage avancée garde vos pieds au chaud dans les conditions les plus froides'
        },
        battery: {
          title: 'Longue Autonomie',
          description: 'Performance toute la journée pour vos plus longues sessions de ski'
        },
        value: {
          title: 'Excellent Rapport Qualité-Prix',
          description: 'Qualité premium à un prix avantageux pour les skieurs sérieux'
        },
        reliable: {
          title: 'Performance Fiable',
          description: 'Testé par plus de 100 skieurs avec des retours unanimement positifs'
        },
        mobileApp: {
          title: 'Application Mobile',
          description: 'Contrôlez votre appareil de chauffage et surveillez l\'utilisation de la batterie avec notre application mobile intuitive'
        }
      },
      reviews: {
        title: 'Ce Que Disent Les Skieurs',
        subtitle: 'Vrais retours de vrais skieurs',
        testimonials: [
          {
            name: 'Sarah M.',
            location: 'Whistler, BC',
            rating: 5,
            text: 'Révolutionnaire! J\'avais l\'habitude de raccourcir mes journées de ski à cause des orteils gelés. Avec ThermoPied, je peux skier toute la journée sans aucune gêne. La batterie dure toute la journée et la chaleur est parfaitement distribuée.'
          },
          {
            name: 'Marc L.',
            location: 'Mont-Tremblant, QC',
            rating: 5,
            text: 'J\'ai essayé d\'autres semelles chauffantes avant, mais ThermoPied est dans une autre catégorie. Le contrôle par application est super pratique et la qualité de fabrication est exceptionnelle. Ça vaut chaque centime!'
          },
          {
            name: 'Jennifer K.',
            location: 'Vail, CO',
            rating: 5,
            text: 'En tant que personne ayant une mauvaise circulation, les pieds froids ont toujours été mon plus grand ennemi sur les pistes. ThermoPied a complètement résolu ce problème. Mes pieds restent chauds même les jours les plus froids. Je recommande vivement!'
          },
          {
            name: 'David R.',
            location: 'Jackson Hole, WY',
            rating: 5,
            text: 'Meilleur investissement que j\'ai fait pour mon équipement de ski! Le chauffage est puissant mais doux, et j\'adore pouvoir ajuster la température en déplacement. La garantie de 3 ans montre qu\'ils soutiennent leur produit.'
          }
        ]
      }
    },
    installation: {
      title: "Guide d'Installation",
      subtitle: 'Suivez ces étapes simples pour installer votre système de chauffage ThermoPied',
      pdfTitle: "Guide d'Installation",
      pdfDescription: "Consultez le guide d'installation complet avec instructions détaillées et diagrammes",
      download: "Voir le Guide",
      steps: [
        {
          title: 'Préparez vos chaussures de ski',
          description: 'Retirez les semelles existantes de vos chaussures de ski et assurez-vous que l\'intérieur est propre et sec.'
        },
        {
          title: 'Positionnez les éléments chauffants',
          description: 'Placez les coussinets chauffants ThermoPied dans vos chaussures, en vous assurant qu\'ils sont correctement alignés avec la zone des orteils et de l\'avant-pied.'
        },
        {
          title: 'Replacez les semelles',
          description: 'Placez vos semelles d\'origine sur les éléments chauffants pour les maintenir en position.'
        },
        {
          title: 'Connectez le bloc-piles',
          description: 'Fixez le bloc-piles solidement au col de la chaussure. Connectez les éléments chauffants à la batterie.'
        },
        {
          title: 'Allumez et ajustez',
          description: 'Allumez le système de chauffage et sélectionnez le niveau de température souhaité. Attendez 5 à 10 minutes pour une chaleur optimale.'
        }
      ],
      proTips: 'Conseils Pro',
      tips: [
        'Testez le système avant d\'aller sur les pistes pour vous assurer que tout fonctionne correctement',
        'Chargez complètement le bloc-piles la veille de votre journée de ski',
        'Commencez avec un réglage de chaleur plus bas et ajustez selon vos besoins pour maximiser l\'autonomie de la batterie'
      ]
    },
    manual: {
      title: 'Application & Manuel d\'Utilisateur',
      subtitle: 'Tout ce que vous devez savoir sur l\'utilisation de ThermoPied',
      pdfTitle: 'Manuel d\'Utilisateur',
      pdfDescription: 'Guide complet avec instructions détaillées, informations de sécurité et conseils de dépannage',
      download: 'Voir le Manuel',
      mobileAppTitle: 'Application Mobile',
      mobileAppDescription: 'Téléchargez ThermoPied depuis l\'Apple Store ou Google Play pour un contrôle complet des réglages de température et une surveillance en temps réel de la batterie.',
      appStore: 'App Store',
      googlePlay: 'Google Play',
      whatsIncluded: 'Ce qui est inclus',
      included: [
        'Instructions d\'installation complètes',
        'Directives d\'utilisation',
        'Entretien de la batterie',
        'Précautions de sécurité',
        'Informations sur la garantie'
      ],
      troubleshooting: 'Dépannage',
      troubleshootingItems: [
        'Problèmes courants et solutions',
        'Conseils d\'optimisation des performances',
        'Diagnostics de la batterie',
        'Informations de contact du support',
        'Section FAQ'
      ]
    },
    about: {
      title: 'À propos de nous',
      subtitle: 'Notre Histoire',
      story: [
        'Nous ne sommes pas une simple entreprise : nous sommes une communauté de skieurs passionnés qui savent à quel point des pieds gelés peuvent gâcher une journée parfaite sur les pistes. Les chaussures de ski haute performance offrent souvent peu de chaleur — et comme vous, nous avons trop souvent dû renoncer à skier à cause du froid.',
        'Déçus par les solutions chauffantes disponibles sur le marché — trop chères, peu fiables, avec une autonomie décevante et des garanties limitées — nous avons décidé de créer notre propre solution.',
        'En avril 2022, nous avons collaboré avec une entreprise d\'électronique en Chine, fondée par l\'un de nos membres, pour concevoir ThermoPied : un chauffe-chaussures de ski haut de gamme, conçu par des skieurs, pour des skieurs.',
        'La première série est arrivée à Montréal en décembre 2023. Plus de 100 skieurs l\'ont testée pendant toute la saison hivernale, et les retours ont été unanimes : ThermoPied offre chaleur, confort et fiabilité, à un prix vraiment avantageux.',
        'ThermoPied, ce n\'est pas un simple accessoire. C\'est l\'équipement que nous aurions voulu avoir depuis longtemps — et il est enfin disponible pour vous.'
      ],
      tagline: 'ThermoPied garde vos pieds au chaud, votre corps en mouvement et votre passion vivante.',
      slogan: 'ThermoPied – Restez au chaud. Continuez à skier.'
    },
    contact: {
      title: 'Contactez-nous',
      subtitle: 'Nous sommes là pour vous aider',
      description: 'Des questions sur ThermoPied ? Besoin d\'assistance ? Nous serions ravis de vous entendre !',
      email: 'Email de support',
  emailAddress: 'info@thermopied.com',
      getInTouch: 'Prenez contact',
      storesTitle: 'Disponible chez les principaux détaillants de ski',
      storesDescription: 'Cette année, nos produits ont été lancés avec succès et sont actuellement disponibles chez les principaux détaillants de ski :',
      stores: [
        { name: 'Lachance Ski Service', url: 'https://skilachance.com/' },
        { name: 'Sports Bromont', url: 'https://www.sportsbromont.com' },
         ,{ name: "Dinardo's Skis & Bikes", url: 'https://www.dinardoskibikehike.com/'},
    { name: "Genetik® | Vélo de montagne & Ski alpin", url: 'https://genetiksport.com/' },
{ name: "Magasin de Ski alpin", url: 'https://brunellesport.com/' },
        { name: 'Camp Base Orford – Pied Sportif', url: 'https://www.campbase.ca' },
        { name: 'Jo et Fred La Place du Ski', url: 'https://laplaceduski.ca/' },
        { name: 'Ski Shop Rive-Sud', url: 'https://www.skishoprivesud.com' }
 

   
      ]
    }
  },
  zh: {
    nav: {
      home: '首页',
      product: '产品',
      installation: '安装',
      manual: '使用手册',
      about: '关于我们',
      contact: '联系我们'
    },
    product: {
      title: 'ThermoPied',
      learnMore: '了解更多',
      whyChoose: '为什么选择 ThermoPied？',
      tagline: '为性能而设计，为舒适而打造，为高山而生。',
      whatsIncluded: '包含内容',
      heatingElements: '一套加热元件',
      batteries: '两块电池',
      chargingCable: '充电线',
      warranty: '3年保修',
      productDescription: '通过我们先进的滑雪靴加热系统体验卓越的温暖和舒适。由滑雪者设计，为滑雪者服务。',
      productGallery: '产品图库',
      technicalSpecs: '技术规格',
      viewSpecs: '查看规格 (PDF)',
      ctaTitle: '准备体验温暖了吗？',
      ctaDescription: '立即获取您的 ThermoPied，从此告别冰冷的双脚。',
      features: {
        warmth: {
          title: '卓越保暖',
          description: '先进的加热技术让您的双脚在最寒冷的条件下保持温暖'
        },
        battery: {
          title: '长电池寿命',
          description: '全天性能，匹配您最长的滑雪时段'
        },
        value: {
          title: '超值',
          description: '以合理的价格为认真的滑雪者提供优质品质'
        },
        reliable: {
          title: '可靠性能',
          description: '经过100多名滑雪者测试，获得一致好评'
        },
        mobileApp: {
          title: '移动应用',
          description: '使用我们直观的移动应用程序控制您的加热设备并监控电池使用情况'
        }
      },
      reviews: {
        title: '滑雪者的评价',
        subtitle: '真实滑雪者的真实反馈',
        testimonials: [
          {
            name: 'Sarah M.',
            location: 'Whistler, BC',
            rating: 5,
            text: '改变游戏规则！我以前常因为脚趾冻僵而缩短滑雪时间。有了 ThermoPied，我可以全天滑雪而不会感到任何不适。电池可以持续一整天，热量分布完美。'
          },
          {
            name: 'Marc L.',
            location: 'Mont-Tremblant, QC',
            rating: 5,
            text: '我以前试过其他加热鞋垫，但 ThermoPied 完全是另一个级别。应用程序控制超级方便，制造质量出色。物有所值！'
          },
          {
            name: 'Jennifer K.',
            location: 'Vail, CO',
            rating: 5,
            text: '作为一个血液循环不好的人，冰冷的双脚一直是我在雪坡上最大的敌人。ThermoPied 完全解决了这个问题。即使在最冷的日子里，我的脚也能保持温暖。强烈推荐！'
          },
          {
            name: 'David R.',
            location: 'Jackson Hole, WY',
            rating: 5,
            text: '这是我为滑雪装备做的最好的投资！加热功能强大而温和，我喜欢可以随时调节温度。3年保修表明他们对自己的产品有信心。'
          }
        ]
      }
    },
    installation: {
      title: '安装指南',
      subtitle: '按照这些简单步骤安装您的 ThermoPied 加热系统',
      pdfTitle: '安装指南',
      pdfDescription: '查看包含详细说明和图表的完整安装指南',
      download: '查看指南',
      steps: [
        {
          title: '准备滑雪靴',
          description: '从滑雪靴中取出现有的鞋垫，确保内部清洁干燥。'
        },
        {
          title: '定位加热元件',
          description: '将 ThermoPied 加热垫放入靴子内，确保它们与脚趾和前脚掌区域正确对齐。'
        },
        {
          title: '更换鞋垫',
          description: '将原鞋垫放回加热元件上方以保持其位置。'
        },
        {
          title: '连接电池组',
          description: '将电池组牢固地固定在靴筒上。将加热元件连接到电池。'
        },
        {
          title: '开机并调节',
          description: '打开加热系统并选择所需的温度级别。等待5-10分钟以获得最佳温暖效果。'
        }
      ],
      proTips: '专业提示',
      tips: [
        '在前往滑雪场之前测试系统，确保一切正常工作',
        '在滑雪前一晚给电池组充满电',
        '从较低的热量设置开始，根据需要调整以最大化电池寿命'
      ]
    },
    manual: {
      title: '应用程序 & 使用手册',
      subtitle: '关于使用 ThermoPied 您需要了解的一切',
      pdfTitle: '使用手册',
      pdfDescription: '包含详细说明、安全信息和故障排除提示的完整指南',
      download: '查看手册',
      mobileAppTitle: '移动应用程序',
      mobileAppDescription: '从 Apple Store 或 Google Play 下载 ThermoPied，完全控制温度设置并实时监控电池寿命。',
      appStore: 'App Store',
      googlePlay: 'Google Play',
      whatsIncluded: '包含内容',
      included: [
        '完整的安装说明',
        '操作指南',
        '电池保养和维护',
        '安全注意事项',
        '保修信息'
      ],
      troubleshooting: '故障排除',
      troubleshootingItems: [
        '常见问题和解决方案',
        '性能优化提示',
        '电池诊断',
        '联系支持信息',
        '常见问题解答'
      ]
    },
    about: {
      title: '关于我们',
      subtitle: '我们的故事',
      story: [
        '我们不仅仅是一家公司——我们是一个充满激情的滑雪者社区，我们深知寒冷的双脚如何毁掉在雪坡上的完美一天。高性能滑雪靴在保暖方面往往不尽如人意，就像你们许多人一样，我们不得不因为脚趾冻僵而过早结束精彩的滑雪。',
        '对现有加热靴解决方案的局限性感到沮丧——无论是高昂的价格、糟糕的电池寿命、不可靠的性能还是薄弱的保修——我们决定自己动手解决这个问题。',
        '2022年4月，我们与中国一家值得信赖的电子公司合作，该公司由我们团队成员之一创立，创造了一个更好的解决方案：ThermoPied——为真正的滑雪者设计的高质量、高性能滑雪靴加热器。',
        '经过一年的开发，我们的第一批产品于2023年12月抵达蒙特利尔。超过100名滑雪者在整个雪季测试了 ThermoPied，反馈一致：温暖、舒适和可靠，价格合理。',
        'ThermoPied 不仅仅是另一个小工具——它是我们多年前就希望拥有的加热器。现在它是你的了。'
      ],
      tagline: 'ThermoPied 让您的双脚保持温暖，身体保持活力，激情永存。',
      slogan: 'ThermoPied – 保持温暖，继续滑雪。'
    },
    contact: {
      title: '联系我们',
      subtitle: '我们随时为您提供帮助',
      description: '对ThermoPied有疑问？需要支持？我们很乐意听到您的声音！',
      email: '客服邮箱',
  emailAddress: 'info@thermopied.com',
      getInTouch: '联系我们',
      storesTitle: '在领先的滑雪零售商处有售',
      storesDescription: '今年，我们的产品已成功推出，目前在主要滑雪零售商处有售：',
      stores: [
        { name: 'Lachance Ski Service', url: 'https://skilachance.com/' },
        { name: 'Sports Bromont', url: 'https://www.sportsbromont.com' },
        { name: 'Camp Base Orford – Pied Sportif', url: 'https://www.campbase.ca' },
        { name: "Dinardo's Skis & Bikes", url: 'https://www.dinardoskibikehike.com/' },
        { name: "Genetik® | Vélo de montagne & Ski alpin", url: 'https://genetiksport.com/' },
        { name: "Magasin de Ski alpin", url: 'https://brunellesport.com/' },
        { name: 'Jo et Fred La Place du Ski', url: 'https://laplaceduski.ca/' },
        { name: 'Ski Shop Rive-Sud', url: 'https://www.skishoprivesud.com' }
      ]
    }
  }
};
